import { AffiliateModel } from '../../../../models/dashboard/marketplace/affiliatesModel';
import { adminHttpClient } from "../../../../commons/adminHttpClinet";


const getAffiliates = (): Promise<Array<AffiliateModel>> => {
    return adminHttpClient.get(`/api/Admin/AdminMarketplace/get-affiliates`)
}
export default getAffiliates;